import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';
import windows from 'assets/windowsIcons/windows.png';
import pullup from 'assets/windowsIcons/pullup.png';
import computer from 'assets/windowsIcons/676(16x16).png';
import dropdown from 'assets/windowsIcons/dropdown.png';
import go from 'assets/windowsIcons/290.png';

const taglines = [
  '"mahip.exe — running since 2018, zero clean shutdowns."',
  '"Loading career.dll... 8 years in, still no errors. (Mostly.)"',
  '"Warning: may spontaneously talk about agentic AI at dinner."',
  '"I ship agents. Not packages."',
  '"40% efficiency gains. 100% meetings survived."',
  '"Prompt-engineered for maximum impact."',
];

function WhoAmI({ onClose }) {
  const [taglineIdx, setTaglineIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setTaglineIdx(i => (i + 1) % taglines.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  function onClickOptionItem(item) {
    if (item === 'Close') onClose();
  }

  return (
    <Div>
      <section className="com__toolbar">
        <div className="com__options">
          <WindowDropDowns items={dropDownData} onClickItem={onClickOptionItem} />
        </div>
        <img className="com__windows-logo" src={windows} alt="windows" />
      </section>
      <section className="com__address_bar">
        <div className="com__address_bar__title">Address</div>
        <div className="com__address_bar__content">
          <img src={computer} alt="" className="com__address_bar__content__img" />
          <div className="com__address_bar__content__text">C:\Users\Mahip\mahip.exe</div>
          <img src={dropdown} alt="" className="com__address_bar__content__img" />
        </div>
        <div className="com__address_bar__go">
          <img className="com__address_bar__go__img" src={go} alt="go" />
          <span className="com__address_bar__go__text">Go</span>
        </div>
      </section>
      <div className="com__content">
        <div className="com__content__inner">
          {/* LEFT PANEL */}
          <div className="com__content__left">
            <div className="avatar-block">
              <img className="avatar-photo" src={`${process.env.PUBLIC_URL}/profile.png`} alt="Mahip Kakan" />
              <div className="avatar-name">Mahip Kakan</div>
              <div className="avatar-role">AI Product Manager</div>
            </div>
            <div className="tagline-box">{taglines[taglineIdx]}</div>
            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">Quick Launch</div>
                <img src={pullup} alt="" className="com__content__left__card__header__img" />
              </div>
              <div className="com__content__left__card__content">
                <div className="com__content__left__card__row">
                  <a href="https://www.linkedin.com/in/mahip-kakan/" target="_blank" rel="noreferrer"
                    className="com__content__left__card__text link">💼 LinkedIn</a>
                </div>
                <div className="com__content__left__card__row">
                  <a href="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7446461748267630592" target="_blank" rel="noreferrer"
                    className="com__content__left__card__text link">📰 Newsletter</a>
                </div>
                <div className="com__content__left__card__row">
                  <a href="https://github.com/mahip-kakan" target="_blank" rel="noreferrer"
                    className="com__content__left__card__text link">🐙 GitHub</a>
                </div>
                <div className="com__content__left__card__row">
                  <a href="https://mahip-kakan.github.io/Work-Flow/" target="_blank" rel="noreferrer"
                    className="com__content__left__card__text link">🧩 Workflow Studio</a>
                </div>
                <div className="com__content__left__card__row">
                  <a href="https://github.com/mahip-kakan/Mahflow/releases/latest" target="_blank" rel="noreferrer"
                    className="com__content__left__card__text link">🎙️ Mahflow</a>
                </div>
                <div className="com__content__left__card__row">
                  <a href="mailto:mahip.ku.kakan@gmail.com"
                    className="com__content__left__card__text link">📧 Email Me</a>
                </div>
                <div className="com__content__left__card__row">
                  <a href="tel:+917735544556"
                    className="com__content__left__card__text link">📞 +91 77355 44556</a>
                </div>
              </div>
            </div>
            <a
              className="libutton"
              href="https://www.linkedin.com/build-relation/newsletter-follow?entityUrn=7446461748267630592"
              target="_blank"
              rel="noreferrer"
            >
              Subscribe on LinkedIn
            </a>
          </div>

          {/* RIGHT PANEL */}
          <div className="com__content__right">
            <div className="com__content__right__card">
              <div className="com__content__right__card__header">⚡ System Status: RUNNING</div>
              <div className="right-summary">
                Mahip specializes in making AI <em>actually do something useful</em> — not just impressive demos that die in the boardroom.
                RAG pipelines, agentic workflows, LLM eval frameworks, enterprise GenAI.
                The kind of stuff that ships, not just ships to a slide deck.
                <div className="meme-note">"Half the time companies say they need AI, they need a SELECT with GROUP BY. The other half? That's where I come in."</div>
              </div>
            </div>

            <div className="com__content__right__card">
              <div className="com__content__right__card__header">🖥️ Currently Running Processes</div>
              <div className="right-summary">
                Agentic retail planning · RAG-based enterprise workflows · LLM evaluation systems ·
                preventing AI hallucinations (mostly) · explaining agents to executives using coffee analogies
              </div>
            </div>
          </div>
        </div>
      </div>
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .com__toolbar {
    position: relative;
    display: flex;
    align-items: center;
    height: 24px;
    border-bottom: 1px solid rgba(255,255,255,0.7);
    flex-shrink: 0;
  }
  .com__options {
    height: 23px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    border-right: 1px solid rgba(0,0,0,0.1);
    padding: 1px 0 1px 2px;
    flex: 1;
  }
  .com__windows-logo {
    height: 100%;
    border-left: 1px solid white;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
  .com__address_bar {
    flex-shrink: 0;
    border-top: 1px solid rgba(255,255,255,0.7);
    height: 20px;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 2px;
    box-shadow: inset 0 -2px 3px -1px #b0b0b0;
  }
  .com__address_bar__title {
    color: rgba(0,0,0,0.5);
    padding: 5px;
  }
  .com__address_bar__content {
    border: rgba(122,122,255,0.6) 1px solid;
    height: 100%;
    display: flex;
    flex: 1;
    align-items: center;
    background-color: white;
    position: relative;
    &__img { width: 14px; height: 14px; }
    &__img:last-child { width: 15px; height: 15px; right: 1px; position: absolute; }
    &__text { white-space: nowrap; position: absolute; left: 16px; right: 17px; }
  }
  .com__address_bar__go {
    display: flex;
    align-items: center;
    padding: 0 18px 0 5px;
    height: 100%;
    position: relative;
    &__img { height: 95%; border: 1px solid rgba(255,255,255,0.2); margin-right: 3px; }
  }
  .com__content {
    flex: 1;
    border: 1px solid rgba(0,0,0,0.4);
    border-top-width: 0;
    background-color: #f1f1f1;
    overflow: auto;
    font-size: 11px;
    position: relative;
  }
  .com__content__inner {
    display: flex;
    height: 100%;
    overflow: auto;
  }
  .com__content__left {
    width: 190px;
    min-width: 190px;
    background: linear-gradient(to bottom, #748aff 0%, #4057d3 100%);
    overflow: auto;
    padding: 10px;
  }
  .avatar-block {
    text-align: center;
    padding: 12px 0 10px;
    color: white;
  }
  .avatar-photo {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    object-fit: cover;
    object-position: center top;
    margin: 0 auto 8px;
    display: block;
    border: 3px solid rgba(255,255,255,0.8);
    box-shadow: 0 2px 10px rgba(0,0,0,0.4);
  }
  .avatar-name {
    font-weight: bold;
    font-size: 12px;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
  }
  .avatar-role {
    font-size: 10px;
    opacity: 0.85;
    margin-top: 2px;
  }
  .tagline-box {
    background: rgba(255,255,255,0.12);
    border: 1px solid rgba(255,255,255,0.3);
    color: #fff;
    font-size: 10px;
    font-style: italic;
    padding: 6px 8px;
    margin: 8px 0;
    line-height: 1.4;
    border-radius: 2px;
    text-shadow: 1px 1px 1px rgba(0,0,0,0.4);
  }
  .com__content__left__card {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 100%;
    overflow: hidden;
    margin-bottom: 12px;
  }
  .com__content__left__card__header {
    display: flex;
    align-items: center;
    height: 23px;
    padding-left: 11px;
    padding-right: 2px;
    background: linear-gradient(to right, rgb(240,240,255) 0, rgb(240,240,255) 30%, rgb(168,188,255) 100%);
    &__text { font-weight: 700; color: #0c327d; flex: 1; font-size: 11px; }
    &__img { width: 18px; height: 18px; }
  }
  .com__content__left__card__content {
    padding: 5px 10px;
    background: linear-gradient(to right, rgb(180,200,251) 0%, rgb(164,185,251) 50%, rgb(180,200,251) 100%);
  }
  .com__content__left__card__row {
    display: flex;
    margin-bottom: 4px;
  }
  .com__content__left__card__text {
    font-size: 10px;
    line-height: 14px;
    color: #0c327d;
    &.link:hover { cursor: pointer; color: #2b72ff; text-decoration: underline; }
  }
  a { color: #0c327d; text-decoration: none; font-size: 10px; line-height: 14px; }
  a:hover { color: #2b72ff; text-decoration: underline; }
  .libutton {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 10px auto 4px;
    padding: 7px;
    text-align: center;
    outline: none;
    text-decoration: none !important;
    color: #ffffff !important;
    width: 200px;
    height: 32px;
    border-radius: 16px;
    background-color: #0A66C2;
    font-family: "SF Pro Text", Helvetica, sans-serif;
    font-size: 13px;
    line-height: 1;
    box-sizing: border-box;
  }
  .libutton:hover {
    color: #ffffff !important;
    text-decoration: none !important;
    filter: brightness(1.08);
  }

  .com__content__right {
    flex: 1;
    overflow: auto;
    background-color: #fff;
  }
  .com__content__right__card {
    border-bottom: 1px solid #dce8ff;
  }
  .com__content__right__card__header {
    font-weight: 700;
    font-size: 11px;
    padding: 5px 12px 4px;
    color: #0c327d;
    position: relative;
    &:after {
      content: '';
      display: block;
      background: linear-gradient(to right, #70bfff 0, #fff 100%);
      position: absolute;
      bottom: 0;
      left: 0;
      height: 1px;
      width: 100%;
    }
  }
  .right-summary {
    padding: 8px 14px 10px;
    font-size: 11px;
    line-height: 1.5;
    color: #222;
  }
  .meme-note {
    margin-top: 8px;
    padding: 6px 10px;
    background: #f5f9ff;
    border-left: 3px solid #7aa2e3;
    font-style: italic;
    color: #444;
    font-size: 10px;
    line-height: 1.4;
  }
  .metrics-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 10px 14px;
  }
  .metric-item {
    background: linear-gradient(180deg, #f9fcff 0%, #eef6ff 100%);
    border: 1px solid #c4d9f8;
    padding: 8px 10px;
  }
  .metric-num {
    font-size: 20px;
    font-weight: bold;
    color: #0a48a8;
    line-height: 1.2;
  }
  .metric-label {
    font-size: 10px;
    color: #444;
    line-height: 1.35;
    margin-top: 2px;
  }
  .clients-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    padding: 10px 14px;
  }
  .client-badge {
    background: linear-gradient(180deg, #e8f2ff 0%, #d0e4ff 100%);
    border: 1px solid #7aa2e3;
    color: #0c327d;
    padding: 3px 9px;
    font-size: 11px;
    font-weight: bold;
  }
`;

export default WhoAmI;
